import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { Router } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faClose, faL } from '@fortawesome/free-solid-svg-icons';
import { Store } from '@ngrx/store';
import moment from 'moment';
import { Subject, distinctUntilChanged, finalize, takeUntil } from 'rxjs';
import { Currencies, PaymentCodes, Products } from '../../../models/app-enums';
import { selectUser } from '../../../ngrx/data.reducer';
import { CommonService } from '../../../services/common.service';
import { HelperService } from '../../../services/helper.service';
import { HttpService } from '../../../services/http.service';
import { LoaderService } from '../../../services/loader.service';
import { ModalService } from '../../../services/modal.service';
import { InputComponent } from '../../input/input.component';
import { MiniLoadingComponent } from '../../loaders/mini-loader/mini-loading.component';
import { ModalComponent } from '../modal/modal.component';
import { ResizeService } from '../../../services/resize.service';
import { CurrencyService } from '../../../services/currency.service';

declare var $: any;

@Component({
  standalone: true,
  imports: [
    CommonModule,
    MiniLoadingComponent,
    ModalComponent,
    FontAwesomeModule,
    InputComponent,
  ],
  selector: 'app-emeet-modal',
  templateUrl: './emeet-modal.component.html',
  styleUrls: ['./emeet-modal.component.scss'],
})
export class EmeetModalComponent implements OnInit, OnDestroy {
  faClose = faClose;
  @Input() sharedCreatorId: number;
  @Input() sharedCreatorPackages: any;
  @Input() sharedCreatorProductPackageId: number;
  @Input() creatorName: string;
  @Input() username: string;
  @Input() creatorEmail: string;
  @Input() freeSlotsEnabled: boolean = false;
  @Output() showFanEmailModal: EventEmitter<any> = new EventEmitter<any>();
  currentUserTimezone: string;
  creatorSlotsTiming: any;
  sortData: any = [];
  Datafilter: any = [];
  isSlotdivLoader: boolean = false;
  isSlotdivtxt: boolean = false;
  packageId: number;
  sessionPrice: number;
  selectedSechduleId: number;
  proceedToPay: boolean = false;
  isLoadingBtn: boolean = false;
  userDetails = null;
  slotData: any;
  menteeId: any = '';
  currentUrl: string = null;
  selectedPackage: any;
  countryCode:string;
  iscountryPK:boolean=false;

  user$ = this.store.select(selectUser);
  private destroy$ = new Subject<void>();
  packages;
  filterPackage;
  constructor(
    private _commonService: CommonService,
    public helper: HelperService,
    private router: Router,
    private store: Store,
    private http: HttpService,
    private modalService: ModalService,
    public resize: ResizeService,
    private currencyService:CurrencyService,
    
  ) {
    this.user$
      .pipe(
        takeUntil(this.destroy$),
        distinctUntilChanged(
          (prev, curr) => JSON.stringify(prev) === JSON.stringify(curr),
        ),
      )
      .subscribe((user) => {
        this.userDetails = user;
      });
    this.modalService
      .getModalStateObservable()
      .pipe(
        takeUntil(this.destroy$),
        distinctUntilChanged(
          (prev, curr) => JSON.stringify(prev) === JSON.stringify(curr),
        ),
      )
      .subscribe((state: any) => {
        this[state?.id] = state?.show;
      });
    this.currentUrl = this.router.url;
    this.currentUserTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (this.userDetails?.id) this.menteeId = this.userDetails?.id;
  }

  ngOnInit(): void {

    this.currencyService.getCountryCodeDefault().subscribe({
    next: (response: any) => {
      this.countryCode = response.country;
      if(this.countryCode=="PK"){
        this.iscountryPK=true;

      }
    },
    error: (err) => {
      console.error('Error getting country code:', err);
      this.countryCode = 'US'; 
    }
  });
  
    this.packageId = this.sharedCreatorPackages[0].id;
    this.sessionPrice = this.sharedCreatorPackages[0].price;
    localStorage.setItem('sessionPrice', JSON.stringify(this.sessionPrice));
    this.selectedPackage = this.sharedCreatorPackages[0];
    this.getCreatorSlots();

  }
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
  scrollToFirstAvailableSlot() {
    const container = $('.buyer');
    const firstAvailableSlot = container
      .find('.datentime:not(.conflict)')
      .first();

    if (firstAvailableSlot.length > 0) {
      const containerTop = container.offset().top;
      const containerBottom = containerTop + container.height();
      const slotTop = firstAvailableSlot.offset().top;
      const slotBottom = slotTop + firstAvailableSlot.height();
      if (slotTop >= containerTop && slotBottom <= containerBottom) {
      } else {
        container.animate(
          {
            scrollTop:
              firstAvailableSlot.offset().top -
              container.offset().top +
              container.scrollTop() -
              250,
          },
          500,
        );
      }
    }
  }
  getCreatorSlots() {
    this.isSlotdivLoader = true;
    this.isSlotdivtxt = false;
    let currentUtcDateTime = moment.utc().format('YYYY-MM-DDTHH:MM:ss');
    this._commonService
      .creatorBookingSlots(
        this.sharedCreatorId,
        this.packageId,
        currentUtcDateTime,
      )
      .pipe(
        takeUntil(this.destroy$),
        finalize(() => {
          this.isSlotdivLoader = false;
          if (this.userDetails) {
            this.getPackages();
          }
        }),
        distinctUntilChanged(
          (prev, curr) => JSON.stringify(prev) === JSON.stringify(curr),
        ),
      )
      .subscribe(
        (response) => {
          if (response.status) {
            this.creatorSlotsTiming = response.objModelList.map((x: any) => {
              const hoursConvert24 = moment(x.fromTiming, 'hh:mm A').format(
                'HH:mm',
              );
              const makeDateFormat = moment(
                x.date + 'T' + hoursConvert24 + 'Z',
                'YYYY-MM-DDTHH:mmZ',
              ).format('dddd DD-MMM-YYYY');
              const fromTimingLocal = moment
                .utc(x.fromTiming, 'LT')
                .local()
                .format('LT');
              const toTimingLocal = moment
                .utc(x.toTiming, 'LT')
                .local()
                .format('LT');
              return {
                ...x,
                fromTiming: fromTimingLocal,
                toTiming: toTimingLocal,
                convertedTime: makeDateFormat,
              };
            });
            this.filterData();
          } else {
            this.isSlotdivtxt = true;
          }
        },
        (err) => {
          this.isSlotdivtxt = true;
        },
      );
  }

  filterData() {
    const groupedData = this.creatorSlotsTiming.reduce((acc, x) => {
      const createData = {
        id: x.id,
        days: x.days,
        fromTiming: x.fromTiming,
        toTiming: x.toTiming,
        date: x.date,
        availablity: x.availablity,
        conflict: x.conflict,
        price: x.price,
        packageID: x.packageID,
        convertedTime: x.convertedTime,
      };

      const existingGroup = acc.find(
        (group) => group.convertedTime === createData.convertedTime,
      );

      if (existingGroup) {
        existingGroup.match.push(createData);
      } else {
        const newGroup = {
          date: createData.date,
          days: createData.days,
          convertedTime: createData.convertedTime,
          match: [createData],
        };
        acc.push(newGroup);
      }
      return acc;
    }, []);

    this.Datafilter = groupedData;
    setTimeout(() => {
      this.scrollToFirstAvailableSlot();
    }, 500);
  }

  selectSechdule(data: any) {
    this.slotData = data;
    this.selectedSechduleId = data.id;
    this.proceedToPay = true;
  }

  selectMentorPackages(value: any) {
    this.isSlotdivLoader = true;
    this.sessionPrice = value.price;
    this.packageId = value.id;
    this.filterPackage = this.packages?.find(
      (item: any) => item?.packageId == this.packageId,
    );
    this.Datafilter = [];
    this.proceedToPay = false;
    this.selectedPackage = value;
    this.getCreatorSlots();
    localStorage.setItem('sessionPrice', JSON.stringify(this.sessionPrice));
  }

  RedirectRequest(type) {
    this.isLoadingBtn = true;
    this.proceedToPayment();
    let paymentRouteData = {
      mentorID: this.sharedCreatorId,
      menteeID: 0,
      slotID: this.selectedSechduleId,
      currencyID: Currencies.dollar,
      paymentCode: '',
      productId: Products.eMeet,
      bookingNo: '',
      productPackageId: null,
      includeWallet: false,
      isReceivedFromMobile: false,
      isRecurring: false,
      type,
      productType:
        this.selectedPackage.packageName +
        ' - ' +
        this.selectedPackage.timeSpan.minutes +
        ' min',
    };
    localStorage.setItem('paymentDetails', JSON.stringify(paymentRouteData));
    localStorage.setItem('slotData', JSON.stringify(this.slotData));
    this.helper.hideModal();
    this.router.navigate(['/payment']);
  }
  proceedToPayment() {
    const productDetails =
      this.selectedPackage.packageName +
      ' - ' +
      this.selectedPackage.timeSpan.minutes +
      ' min';
    this._commonService.pixelAction(
      'Proceed to Payment',
      this.userDetails?.id,
      this.router.url,
      this.creatorName,
      'eMeet',
      this.sessionPrice,
      this.creatorEmail,
      null,
      null,
      null,
      productDetails,
      this.username,
    );
  }
  getPackages() {
    this.http
      .get(`api/product/package/isexist/${this.sharedCreatorId}`, true, true)
      .pipe(
        takeUntil(this.destroy$),
        distinctUntilChanged(
          (prev, curr) => JSON.stringify(prev) === JSON.stringify(curr),
        ),
      )
      .subscribe((response) => {
        this.packages = response?.modelList;
        this.filterPackage = this.packages.find(
          (item: any) => item.packageId == this.packageId,
        );
      });
  }
  redirectPackageBooking() {
    this.isLoadingBtn = true;
    this.proceedToPayment();
    let paymentRouteData = {
      mentorID: this.sharedCreatorId,
      menteeID: 0,
      slotID: this.selectedSechduleId,
      currencyID: Currencies.dollar,
      paymentCode: this.freeSlotsEnabled ? PaymentCodes.Stripe : '',
      productId: Products.eMeet,
      bookingNo: '',
      productPackageId: null,
      includeWallet: false,
      isReceivedFromMobile: false,
      isRecurring: false,
      productType:
        this.selectedPackage.packageName +
        ' - ' +
        this.selectedPackage.timeSpan.minutes +
        ' min',
    };
    localStorage.setItem(
      'packageDetails',
      JSON.stringify(
        this.filterPackage || {
          freeSlotsEnabled: this.freeSlotsEnabled,
          paymentCode: PaymentCodes.Stripe,
        },
      ),
    );
    localStorage.setItem('paymentDetails', JSON.stringify(paymentRouteData));
    localStorage.setItem('slotData', JSON.stringify(this.slotData));
    this.helper.hideModal();
    this.router.navigate(['/payment']);
  }
  showModal() {
    this.helper.hideModal();
    this.showFanEmailModal.emit(true);
  }
  informMe() {
    const data = {
      creatorId: this.sharedCreatorId,
      fanEmail: this.userDetails?.email,
    };
    this.http
      .loaderPost('api/Home/Inform-me', data, false, true)
      .subscribe((response) => {
        this.helper.hideModal();
        this.helper.showModal(false, 'emeetModal');
        LoaderService.loader.next(false);
      });
  }
}
